import Vue from 'vue'
import VueRouter from 'vue-router'
import fixed_menuitems from "@/router/fixed_menuitems";
import store from "@/store";
import DefaultView from "@/views/DefaultView.vue";
import PageLogin from "@/views/PageLogin.vue";


Vue.use(VueRouter)
const DEFAULT_TITLE = 'SIE Portal';
const routes = [
    {
        path: '/',
        name: 'home',
        component: DefaultView,
        redirect: "/dashboard",
        children: [
            ...fixed_menuitems
        ],
        beforeEnter: (to, from, next) => {
            console.log("router BeforeEnter", store.getters["auth/authenticated"], to)
            if (!store.getters["auth/authenticated"] && to.name !== 'login') {
                return next("/login")
            }
            return next()
        },
    },
    {
        path: '/login',
        name: 'login',
        component: PageLogin,
    }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || DEFAULT_TITLE;
    return next()
})
export default router


// const router_loader = store.dispatch("menu/load_menu").then(menu_routes => {
//     console.info("router/index.js", menu_routes, store.state.menu.menuitems)
//     const routes = base_routes(store.state.menu.menuitems)
//     let new_router = new VueRouter({routes})
//     new_router.afterEach((to,) => {
//         console.info("new_router.afterEach", to)
//         Vue.nextTick(() => {
//             document.title = to.meta.title || DEFAULT_TITLE;
//         });
//     })
//     return new_router
// })

// export default router_loader
